import SurchargeSelector from "./SurchargeSelector";

export default function TariffInputForm({
  form,
  tariff,
  suppliers,
  errors,
  onChange,
  onCalculate,
  onSaveOffer,
}) {
  const tariffTypes = tariff.tariffTypes || [];
  const packageTypes = Object.entries(tariff.packageMinimumWeightsKg || {});
  const fieldHasError = (fieldName) =>
    errors.some((error) => error.toLowerCase().includes(fieldName.toLowerCase()));
  const update = (patch) => onChange({ ...form, ...patch });

  return (
    <section className="card tariff-input-card">
      <div className="section-head">
        <div>
          <h2>Sendung berechnen</h2>
          <p className="section-text">
            Grundlage: {tariff.carrierName} Stueckgut Deutschland {tariff.tariffYear}.
          </p>
        </div>
        <div className="entry-summary">
          <span>{form.recipientPostalCode || "Keine PLZ"}</span>
          <span>{form.palletCount || 0} Paletten</span>
        </div>
      </div>

      {errors.length > 0 && (
        <div className="message message-error tariff-error-list">
          {errors.map((error) => (
            <div key={error}>{error}</div>
          ))}
        </div>
      )}

      <div className="form-grid columns-3 tariff-form-grid">
        <label className="field">
          <span>Spedition</span>
          <select value={form.carrierId} onChange={(event) => update({ carrierId: event.target.value })}>
            <option value={tariff.carrierId || "kuehne-nagel"}>{tariff.carrierName || "Kuehne+Nagel"}</option>
          </select>
        </label>

        <label className="field">
          <span>Tarifart</span>
          <select value={form.tariffTypeId} onChange={(event) => update({ tariffTypeId: event.target.value })}>
            {tariffTypes.map((tariffType) => (
              <option key={tariffType.id} value={tariffType.id}>
                {tariffType.label}
              </option>
            ))}
          </select>
        </label>

        <label className="field">
          <span>Kunde</span>
          <select value={form.customer} onChange={(event) => update({ customer: event.target.value })}>
            <option value="">Optional auswaehlen</option>
            {suppliers.map((supplier) => (
              <option key={supplier.id} value={supplier.name}>
                {supplier.customerNumber
                  ? `${supplier.short} - ${supplier.customerNumber}`
                  : supplier.short}
              </option>
            ))}
          </select>
        </label>

        <label className={`field ${fieldHasError("Absender") ? "field-error" : ""}`}>
          <span>Absender-PLZ</span>
          <input
            value={form.senderPostalCode}
            inputMode="numeric"
            maxLength="5"
            onChange={(event) => update({ senderPostalCode: event.target.value.replace(/\D/g, "") })}
          />
        </label>

        <label className={`field ${fieldHasError("Empfaenger") ? "field-error" : ""}`}>
          <span>Empfaenger-PLZ</span>
          <input
            value={form.recipientPostalCode}
            inputMode="numeric"
            maxLength="5"
            placeholder="10115"
            onChange={(event) => update({ recipientPostalCode: event.target.value.replace(/\D/g, "") })}
          />
        </label>

        <label className="field">
          <span>Packmittelart</span>
          <select value={form.packageTypeId} onChange={(event) => update({ packageTypeId: event.target.value })}>
            {packageTypes.map(([key, packageType]) => (
              <option key={key} value={key}>
                {packageType.label}
              </option>
            ))}
          </select>
        </label>

        <label className={`field ${fieldHasError("Palette") ? "field-error" : ""}`}>
          <span>Anzahl Paletten</span>
          <input
            type="number"
            min="1"
            step="1"
            value={form.palletCount}
            onChange={(event) => update({ palletCount: event.target.value })}
          />
        </label>

        <label className="field">
          <span>Laenge je Palette cm</span>
          <input type="number" min="0" value={form.lengthCm} onChange={(event) => update({ lengthCm: event.target.value })} />
        </label>

        <label className="field">
          <span>Breite je Palette cm</span>
          <input type="number" min="0" value={form.widthCm} onChange={(event) => update({ widthCm: event.target.value })} />
        </label>

        <label className="field">
          <span>Hoehe je Palette cm</span>
          <input type="number" min="0" value={form.heightCm} onChange={(event) => update({ heightCm: event.target.value })} />
        </label>

        <label className={`field ${fieldHasError("Gewicht") ? "field-error" : ""}`}>
          <span>Tatsaechliches Gesamtgewicht kg</span>
          <input type="number" min="0" value={form.actualWeightKg} onChange={(event) => update({ actualWeightKg: event.target.value })} />
        </label>

        <label className="field field-wide">
          <span>Notiz</span>
          <textarea
            rows="3"
            value={form.note}
            placeholder="Optional fuer gespeicherte Angebote"
            onChange={(event) => update({ note: event.target.value })}
          />
        </label>
      </div>

      <div className="tariff-subsection">
        <h3>Zuschlaege</h3>
        <SurchargeSelector
          tariff={tariff}
          surcharges={form.surcharges}
          onChange={(surcharges) => update({ surcharges })}
        />
      </div>

      <div className="button-row action-bar-sticky">
        <button type="button" className="button button-primary" onClick={onCalculate}>
          Preis berechnen
        </button>
        <button type="button" className="button button-dark" onClick={onSaveOffer}>
          Angebot speichern
        </button>
      </div>
    </section>
  );
}

